import StatusPill from '../StatusPill/StatusPill'
import type { StatusPillItem } from '../types'
import { StyledPills } from '../styled-components'

interface StatusPillsProps {
  items: StatusPillItem[]
}

const StatusPills = ({ items }: StatusPillsProps) => (
  <StyledPills>
    {items.map(item => (
      <StatusPill key={item.key} label={item.label} state={item.state} />
    ))}
  </StyledPills>
)

export default StatusPills
